function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}import "./navbar.scss";
import template from "./navbar.html";

export var NavbarComponent = {
  template: template,
  bindings: {
    user: '<',
    metabolicType: '<' },

  controllerAs: 'vm',
  controller:
  function NavbarComponentController() {_classCallCheck(this, NavbarComponentController);
    console.warn(this);
  } };